

































































































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import vSelect from 'vue-select';
import { required } from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { Product, ProductsApi } from '../../../../api';
import Toast from '@/components/display/toast.vue';
import SitePicker from '@/components/site-picker.vue';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import moment from 'moment';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
@Component({
	components: {
		secondaryNav,
		vSelect,
		SitePicker,
	},
	validations: {
		form: {
			site: { required },
		},
	},
	mixins: [validationMixin],
})
export default class ProductUpdate extends Vue {
	public form = {
		plan: '',
		trialPlan: '',
		trialEndsAt: '',
		site: {},
		name: '',
	};

	public planOptions = [
		{ value: 'regular', text: 'Regular' },
		{ value: 'premium', text: 'Premium' },
	];

	public trialPlanOptions = [
		{ value: 'premium', text: 'Premium' },
		{ value: null, text: 'No Trial' },
	];

	public statusOptions = [
		{ value: 'removed', text: 'Removed' },
		{ value: 'cancelled', text: 'Cancelled' },
		{ value: 'pending', text: 'Pending' },
		{ value: 'install', text: 'Install' },
		{ value: 'sign-off', text: 'Sign-Off' },
		{ value: 'live', text: 'Live' },
		{ value: 'onhold', text: 'On-Hold' },
	];

	public product: any = null;

	public $bvToast: any;
	public loading = true;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
	}

	public getTrialPlanOptions() {
		switch (this.form.plan) {
			case 'trial':
				this.trialPlanOptions = [
					{ value: 'premium', text: 'Premium' },
					{ value: 'regular', text: 'Regular' },
					{ value: null, text: 'No Trial' },
				];
				this.form.trialPlan = null;
				break;
			case 'premium':
				this.trialPlanOptions = [{ value: null, text: 'No Trial' }];
				this.form.trialPlan = null;
				break;
			default:
				this.trialPlanOptions = [
					{ value: 'premium', text: 'Premium' },
					{ value: null, text: 'No Trial' },
				];
				break;
		}
	}

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		if (this.form.trialPlan == null) {
			this.form.trialEndsAt = '';
		}

		const { productId } = this.$route.params;
		const product: Product = this.product;
		product.name = this.form.name;
		product.plan = this.form.plan;
		product.trialPlan = this.form.trialPlan;
		product.trialEndsAt = this.form.trialEndsAt;
		product.siteId = this.form.site.id;
		product.status = this.form.status;
		// product.notes = this.form.notes;
		try {
			await new ProductsApi().updateProduct(parseInt(productId, 10), { data: product });
		} catch (e) {
			let error;
			if (e.response) {
				error = 'Product not updated ' + e.response.data.message;
			} else if (e.request) {
				error = 'Product not updated, network Error';
			} else {
				error = 'Product not updated, unknown Error';
			}
			new Toast().makeToast(error, 'Error Updating Product', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Product Updated', 'Successfully', 'success');

		setTimeout(() => {
			this.submitStatus = 'OK';
			this.$router.push({ name: 'products.effluent.view', params: { productId } });
		}, 1000);
	}

	public async load() {
		const { productId } = this.$route.params;
		this.submitStatus = 'OK';
		this.loading = true;

		try {
			const response = await this.api.getProductById(parseInt(productId, 10), {
				params: { include: 'org,site,subscriptionitem' },
			});
			const product: Product = response.data;
			this.form.status = product.status;

			if (product.subscriptionitem !== null) {
				this.form.plan = product.subscriptionitem.plan;
				this.form.trialPlan = product.subscriptionitem.trialPlan;
				this.form.trialEndsAt = product.subscriptionitem.trialEndsAt;
			} else {
				this.form.plan = product.plan;
			}
			this.form.site = product.site;
			this.form.name = product.name;

			this.product = product;
		} catch (e) {
			this.product = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
